import { QSetExamUsageStatusTag, QSetStatusTag } from '@exam-management/components';
import type { QSet } from '@exam-management/graphql';
import { EllipsisText, type GridColDef } from '@shared/components';
import { formatDateTime } from '@shared/utils';

import { MoreActionMenu } from '../more-action-menu';

interface PublishedQSetColumn {
  id: QSet['id'];
  code: QSet['code'];
  status: QSet['status'];
  lastPublishedAt: QSet['lastPublishedAt'];
  examUsageStatus: QSet['examUsageStatus'];
  qConfig: {
    code: QSet['qConfig']['code'];
    name: QSet['qConfig']['name'];
  };
  updatedAt: QSet['updatedAt'];
}

export const columns: GridColDef<PublishedQSetColumn>[] = [
  {
    field: 'code',
    headerName: 'QSet ID',
    sortable: false,
    minWidth: 112,
    flex: 1,
    renderCell: (params) => {
      return <EllipsisText>{params.row.code}</EllipsisText>;
    },
  },
  {
    field: 'qConfig.name',
    headerName: 'QConfig Name',
    sortable: false,
    flex: 1,
    minWidth: 206,
    renderCell: (params) => {
      return <EllipsisText>{params.row.qConfig.name}</EllipsisText>;
    },
  },
  {
    field: 'qConfig.code',
    headerName: 'QConfig ID',
    sortable: false,
    width: 120,
    renderCell: (params) => {
      return <EllipsisText>{params.row.qConfig.code}</EllipsisText>;
    },
  },
  {
    field: 'status',
    headerName: 'Status',
    sortable: false,
    flex: 1,
    minWidth: 206,
    renderCell: (params) => {
      return <QSetStatusTag status={params.row.status} size='large' />;
    },
  },
  {
    field: 'lastPublishedAt',
    headerName: 'Published at',
    flex: 1,
    minWidth: 206,
    renderCell: (params) => {
      return <>{params.row.lastPublishedAt ? formatDateTime(params.row.lastPublishedAt) : '-'}</>;
    },
  },
  {
    field: 'examUsageStatus',
    headerName: 'Exam Usage',
    width: 120,
    sortable: false,
    renderCell: (params) => {
      const { examUsageStatus } = params.row;
      return examUsageStatus ? <QSetExamUsageStatusTag status={examUsageStatus} /> : '-';
    },
  },
  {
    field: 'moreAction',
    headerName: '',
    width: 48,
    sortable: false,
    renderCell: (params) => <MoreActionMenu qSetId={params.row.id} status={params.row.status} />,
  },
];
